import groupBy from 'lodash/groupBy'
import sum from 'lodash/sum'

import i18n from 'modules/core/lib/i18n'

import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import type { ShiftsRow } from 'modules/shift_management/lib/types'
import { usePlannedBreaks } from 'modules/time_planning/store/internal/collections/plannedBreaks'

import HoursDisplay, { Element, formatDuration } from './HoursDisplay'

interface Props {
  shiftsRow: ShiftsRow
}

const PlannedHours = ({ shiftsRow }: Props) => {
  const [{ view }] = useSchedule()
  // TODO: Remove this once 'dev_shift_management_graphql_migration' and
  // the mutations are done to use only shift.plannedBreaks
  const plannedBreaksCollection = usePlannedBreaks()

  const totalDuration = formatDuration(
    shiftsRow.hoursPerRangeAsMilliseconds(view.firstDay, view.lastDay, plannedBreaksCollection)
  )
  const shiftsByName = groupBy(
    shiftsRow.shiftsPerRange(view.firstDay, view.lastDay),
    (shift) => shift.name || i18n.t('shift_management.hours_information.unnamed_shift')
  )
  const sortedShiftEntries = Object.entries(shiftsByName).sort(([a], [b]) => a.localeCompare(b))

  return (
    <HoursDisplay
      title={i18n.t('shift_management.hours_information.planned_hours.title')}
      totalDuration={totalDuration}
      hideBody={sortedShiftEntries.length === 0}
    >
      {sortedShiftEntries.map(([shiftName, shifts]) => (
        <Element
          key={shiftName}
          title={`${shiftName} (${shifts.length})`}
          value={formatDuration(
            sum(
              shifts.map((shift) =>
                shift.durationWithBreaks(
                  shift.plannedBreaks?.plannedBreaks ||
                    // TODO: Remove this once 'dev_shift_management_graphql_migration' and
                    // the mutations are done to use only shift.plannedBreaks
                    plannedBreaksCollection.filterByShift(shift.id) ||
                    []
                )
              )
            )
          )}
        />
      ))}
    </HoursDisplay>
  )
}

export default PlannedHours
